import { AccountPageLayout } from "@Components/game/account";
import { BybButtonVR, BybMenuItem, BybTextFieldAlt } from "@Components/game/common";
import useI18n from "@i18n";
import { Stack } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { AddProfileProvider, useAddProfile } from "@Context/common/account/add-profile-context";
import { Events } from "@Context/common/general/context";
import VRHeaderButtonType from "@Enums/VRHeaderButtonType";
import { closeKeyboard } from "@Services/keyboard-service";
import { useEffect } from "react";

const AddProfileContent = () => {
  const { i18n } = useI18n();
  const { roles, dob, handleDobChange, handleCancel } = useAddProfile();

  useEffect(() => {
    Events.app.showHeaderButton.emit({ type: VRHeaderButtonType.BACK, title: i18n("account.profile.add.title") });
    Events.app.setHeaderAltSections.emit({
      centerSection: <></>,
      rightSection: <></>,
    });

    return () => {
      Events.app.hideHeaderButton.emit();
      Events.app.setHeaderAltSections.emit(null);
      closeKeyboard();
    };
  }, []);

  return (
    <AccountPageLayout
      pageId="ADD_PROFILE"
      title={i18n("account.profile.add.title")}
      description={i18n("account.profile.add.subtitle")}
      sx={{ height: "100%" }}
    >
      <Stack sx={{ height: "100%", justifyContent: "space-between", alignItems: "center" }}>
        <Stack spacing={1.5}>
          <Stack direction="row" spacing={1.5}>
            <BybTextFieldAlt id="firstName" name="firstName" label={i18n("account.profile.add.first.label")} placeholder="John" fullWidth />
            <BybTextFieldAlt id="lastName" name="lastName" label={i18n("account.profile.add.last.label")} placeholder="Doe" fullWidth />
          </Stack>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
              value={dob}
              minDate={new Date("01/01/1920")}
              maxDate={new Date(new Date().getTime() - 410240376000)}
              onChange={handleDobChange}
              renderInput={(params) => <BybTextFieldAlt {...params} />}
              InputProps={{
                id: "account-dob",
              }}
              label={i18n("account.profile.add.dob.label")}
            />
          </LocalizationProvider>
          {roles.length > 0 && (
            <BybTextFieldAlt name="role" defaultValue={roles[2].name} fullWidth select label={i18n("account.profile.add.role.label")}>
              {roles.map((role) => (
                <BybMenuItem key={role.id} value={role.name}>
                  {i18n(`roles.${role.name}`)}
                </BybMenuItem>
              ))}
            </BybTextFieldAlt>
          )}
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: "auto", pt: 4 }}>
          <BybButtonVR color="secondary" onClick={handleCancel}>
            {i18n("account.profile.add.button.cancel")}
          </BybButtonVR>
          <BybButtonVR color="primary" onClick={() => {}}>
            {i18n("account.profile.add.button.submit")}
          </BybButtonVR>
        </Stack>
      </Stack>
    </AccountPageLayout>
  );
};

const AddProfile = () => {
  return (
    <AddProfileProvider>
      <AddProfileContent />
    </AddProfileProvider>
  );
};

export default AddProfile;
